import MicroModal from 'micromodal';

export const Modals = (function () {
	'use strict';

	function prefillContactForm(modal) {
		// Only pre-fill if this is the contact modal
		if (modal.id !== 'contact') return;
		
		// Check if form has already been pre-filled (to prevent duplicate processing)
		if (modal.dataset.prefilled === 'true') return;
		
		// Get all form fields that should be read-only
		const nameField = modal.querySelector('input[name="sender-name"]');
		const emailField = modal.querySelector('input[name="sender-email"]');
		const companyField = modal.querySelector('input[name="sender-company"]');
		
		// Pre-fill form fields with user data if available
		if (window.wpUser && window.wpUser.isLoggedIn) {
			if (nameField && window.wpUser.name) {
				nameField.value = window.wpUser.name;
			}
			
			if (emailField && window.wpUser.email) {
				emailField.value = window.wpUser.email;
			}
			
			if (companyField && window.wpUser.company) {
				companyField.value = window.wpUser.company;
			}
		}
		
		// Make all these fields read-only regardless of whether they have data
		if (nameField) {
			nameField.setAttribute('readonly', 'readonly');
		}
		
		if (emailField) {
			emailField.setAttribute('readonly', 'readonly');
		}
		
		if (companyField) {
			companyField.setAttribute('readonly', 'readonly');
		}
		
		// Mark as pre-filled to prevent duplicate processing
		modal.dataset.prefilled = 'true';
	}

	function addUserInfoToPreview(modal) {
		const modalContent = modal.querySelector('.modal-content');

		if (!modalContent) return;

		if (!window.wpUser || !window.wpUser.isLoggedIn) return;

		// Check if user info has already been added (to prevent duplicates)
		if (modal.querySelector('.user-info')) return;

		const div = document.createElement('div');
		div.className = 'user-info';
		
		let userInfoHTML = '';
		
		// Create elements safely to prevent XSS
		if (window.wpUser.name) {
			const nameElement = document.createElement('p');
			nameElement.className = 'user-info__name';
			nameElement.textContent = window.wpUser.name;
			div.appendChild(nameElement);
		}
		
		if (window.wpUser.company) {
			const companyElement = document.createElement('p');
			companyElement.className = 'user-info__company';
			companyElement.textContent = window.wpUser.company;
			div.appendChild(companyElement);
		}
		
		if (window.wpUser.email) {
			const emailElement = document.createElement('p');
			emailElement.className = 'user-info__email';
			emailElement.textContent = window.wpUser.email;
			div.appendChild(emailElement);
		}

		// Add logout link (this is safe since it's hardcoded)
		const logoutElement = document.createElement('p');
		logoutElement.className = 'user-info__logout';
		logoutElement.innerHTML = 'Not you? <a href="/logout/">Log out</a>';
		div.appendChild(logoutElement);
		modalContent.prepend(div);
	}

	function moveResponseOutput(modal) {
		// Only process contact modal
		if (modal.id !== 'contact') return;
		
		// Find the response output element
		const responseOutput = modal.querySelector('.wpcf7-response-output');
		if (!responseOutput) return;
		
		// Check if it's already been moved (to prevent duplicate processing)
		if (responseOutput.dataset.moved === 'true') return;
		
		// Find the header and main content areas
		const modalHeader = modal.querySelector('.modal-header');
		const modalContent = modal.querySelector('.modal-content');
		if (!modalHeader || !modalContent) return;
		
		// Find the form to check its state
		const form = modal.querySelector('form');
		
		if (form) {
			// Check if we have actual message content before proceeding
			const hasMessageContent = responseOutput.textContent.trim().length > 0;
			if (!hasMessageContent) return; // Exit early if no content
			
			// Remove any existing status classes and icons
			responseOutput.classList.remove('wpcf7-response-success', 'wpcf7-response-error');
			
			// Remove any existing SVG icons
			const existingIcon = responseOutput.querySelector('.response-icon');
			if (existingIcon) {
				existingIcon.remove();
			}
			
			// Add appropriate class and icon based on form state
			if (form.classList.contains('sent')) {
				// Success states
				responseOutput.classList.add('wpcf7-response-success');
				
				// Add success SVG icon
				const successIcon = document.createElement('span');
				successIcon.className = 'response-icon response-icon-success';
				successIcon.innerHTML = `
					<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
					<path d="M14.0001 0.666504C6.64008 0.666504 0.666748 6.63984 0.666748 13.9998C0.666748 21.3598 6.64008 27.3332 14.0001 27.3332C21.3601 27.3332 27.3334 21.3598 27.3334 13.9998C27.3334 6.63984 21.3601 0.666504 14.0001 0.666504ZM11.3334 20.6665L4.66675 13.9998L6.54675 12.1198L11.3334 16.8932L21.4534 6.77317L23.3334 8.6665L11.3334 20.6665Z" fill="#55A51C"/>
					</svg>
				`;
				responseOutput.insertBefore(successIcon, responseOutput.firstChild);
				
			} else if (
				form.classList.contains('failed') || 
				form.classList.contains('aborted') || 
				form.classList.contains('spam') || 
				form.classList.contains('invalid') || 
				form.classList.contains('unaccepted') || 
				form.classList.contains('payment-required')
			) {
				// Error states
				responseOutput.classList.add('wpcf7-response-error');
				
				// Add error SVG icon
				const errorIcon = document.createElement('span');
				errorIcon.className = 'response-icon response-icon-error';
				errorIcon.innerHTML = `
					<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
					<g clip-path="url(#clip0_1821_1431)">
					<circle cx="15.9999" cy="16.0002" r="12.2336" fill="white"/>
					<path d="M16.0001 2.6665C8.62675 2.6665 2.66675 8.6265 2.66675 15.9998C2.66675 23.3732 8.62675 29.3332 16.0001 29.3332C23.3734 29.3332 29.3334 23.3732 29.3334 15.9998C29.3334 8.6265 23.3734 2.6665 16.0001 2.6665ZM22.6667 20.7865L20.7867 22.6665L16.0001 17.8798L11.2134 22.6665L9.33341 20.7865L14.1201 15.9998L9.33341 11.2132L11.2134 9.33317L16.0001 14.1198L20.7867 9.33317L22.6667 11.2132L17.8801 15.9998L22.6667 20.7865Z" fill="#E23B30"/>
					</g>
					<defs>
					<clipPath id="clip0_1821_1431">
					<rect width="32" height="32" fill="white"/>
					</clipPath>
					</defs>
					</svg>
				`;
				responseOutput.insertBefore(errorIcon, responseOutput.firstChild);
			}
		}
		
		// Clone and replace approach: Keep original in place, reuse existing clone or create new one
		// This allows Contact Form 7 to update the original while we display the clone
		let responseOutputClone = modal.querySelector('.response-output-clone');
		
		if (!responseOutputClone) {
			// Create new clone if none exists
			responseOutputClone = responseOutput.cloneNode(true);
			responseOutputClone.classList.add('response-output-clone');
			responseOutputClone.removeAttribute('data-moved'); // Don't mark clone as moved
			
			// Insert clone between header and main content
			modalHeader.insertAdjacentElement('afterend', responseOutputClone);
		} else {
			// Reuse existing clone - update its content
			responseOutputClone.innerHTML = responseOutput.innerHTML;
		}
		
		// Hide the original response output (keep it functional but invisible)
		responseOutput.style.display = 'none';
		
		// Mark as moved to prevent duplicate processing
		responseOutput.dataset.moved = 'true';
		
		// Set up MutationObserver to sync content from original to clone
		// This ensures the clone stays updated when Contact Form 7 changes the original
		let isUpdating = false; // Flag to prevent circular updates
		
		const observer = new MutationObserver(function(mutations) {
			// Prevent circular updates
			if (isUpdating) return;
			
			mutations.forEach(function(mutation) {
				if (mutation.type === 'childList' || mutation.type === 'attributes') {
					// Set flag to prevent circular updates
					isUpdating = true;
					
					// Sync the clone with the updated original immediately
					responseOutputClone.innerHTML = responseOutput.innerHTML;
					
					// Check if content is empty (thinking state) and hide/show clone accordingly
					const hasContent = responseOutput.textContent.trim().length > 0;
					if (hasContent) {
						responseOutputClone.style.display = '';
					} else {
						responseOutputClone.style.display = 'none';
					}
					
					// Reset flag after a short delay
					setTimeout(() => {
						isUpdating = false;
					}, 50);
				}
			});
		});
		
		// Start observing the original response output for changes
		observer.observe(responseOutput, {
			childList: true,
			attributes: true,
			subtree: true
		});
		
		// Store observer reference for cleanup
		responseOutput.dataset.observer = 'true';
	}

	function cleanupModalState(modal) {
		// Reset the pre-filled flag so it can be re-initialized next time
		if (modal.dataset.prefilled) {
			delete modal.dataset.prefilled;
		}
		
		// Remove user info preview if it exists
		const userInfo = modal.querySelector('.user-info');
		if (userInfo) {
			userInfo.remove();
		}
		
		// Clean up response output clone and observer
		const responseOutput = modal.querySelector('.wpcf7-response-output');
		if (responseOutput && responseOutput.dataset.moved) {
			// Remove the moved flag
			delete responseOutput.dataset.moved;
			
			// Show the original response output again
			responseOutput.style.display = '';
		}
		
		// Remove any response output clones
		const clones = modal.querySelectorAll('.response-output-clone');
		clones.forEach(clone => {
			clone.remove();
		});
	}

	function initContactFormListeners() {
		// Listen for Contact Form 7 specific events and apply styling after a short delay
		document.addEventListener('wpcf7mailsent', function(event) {
			const form = event.target;
			const modal = form.closest('.modal');
			
			if (modal && modal.id === 'contact') {
				// Reset moved flag and apply success styling after Contact Form 7 finishes rendering
				setTimeout(() => {
					const responseOutput = modal.querySelector('.wpcf7-response-output');
					if (responseOutput && responseOutput.dataset.moved) {
						delete responseOutput.dataset.moved;
					}
					// Force the form to be in 'sent' state for our function
					form.classList.add('sent');
					moveResponseOutput(modal);
				}, 50); // Short delay to let Contact Form 7 finish rendering
			}
		});
		
		document.addEventListener('wpcf7invalid', function(event) {
			const form = event.target;
			const modal = form.closest('.modal');
			
			if (modal && modal.id === 'contact') {
				// Reset moved flag and apply error styling after Contact Form 7 finishes rendering
				setTimeout(() => {
					const responseOutput = modal.querySelector('.wpcf7-response-output');
					if (responseOutput && responseOutput.dataset.moved) {
						delete responseOutput.dataset.moved;
					}
					moveResponseOutput(modal);
				}, 50); // Short delay to let Contact Form 7 finish rendering
			}
		});
		
		document.addEventListener('wpcf7mailfailed', function(event) {
			const form = event.target;
			const modal = form.closest('.modal');
			
			if (modal && modal.id === 'contact') {
				// Reset moved flag and apply error styling after Contact Form 7 finishes rendering
				setTimeout(() => {
					const responseOutput = modal.querySelector('.wpcf7-response-output');
					if (responseOutput && responseOutput.dataset.moved) {
						delete responseOutput.dataset.moved;
					}
					moveResponseOutput(modal);
				}, 50); // Short delay to let Contact Form 7 finish rendering
			}
		});
	}

	const config = {
		disableScroll: true,
		disableFocus: false,
		awaitOpenAnimation: true,
		awaitCloseAnimation: true,
		onShow: function (modal) {
			// Remove inert attribute when modal opens
			modal.removeAttribute('inert');
			// Ensure is-open class is added
			modal.classList.add('is-open');
			
			const newUrl =
				window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search + '#' + modal.id;
			history.replaceState(null, null, newUrl);

			// Check for videos in modal
			const videos = modal.querySelectorAll('video');
			videos.forEach(video => {
				video.play();
			});
			
			// Pre-fill contact form fields
			prefillContactForm(modal);

			// Add user info to preview
			addUserInfoToPreview(modal);
		},
		onClose: function (modal) {
			// Add inert attribute when modal closes
			modal.setAttribute('inert', '');
			// Ensure is-open class is removed
			modal.classList.remove('is-open');
			
			const newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search;
			history.replaceState(null, null, newUrl);

			// Pause videos in modal
			const videos = modal.querySelectorAll('video');
			videos.forEach(video => {
				video.pause();
			});
			
			// Clean up modal state
			cleanupModalState(modal);
		},
	};

	function init() {
		// Check if MicroModal is available
		if (typeof MicroModal === 'undefined') {
			console.error('MicroModal not loaded!');
			return;
		}
		
		MicroModal.init(config);

		checkForHash();
		openFromHref();
		initContactFormListeners(); // Initialize Contact Form 7 listeners
	}

	function checkForHash(){
		const hash = window.location.hash;
		if (hash) {
			const modalElement = document.querySelector(hash + '.modal');
			if (modalElement) {
				show(hash.replace('#', ''));
			}
		}
	}

	function openFromHref(){
		document.addEventListener('click', function(e) {
			if (e.target.tagName === 'A') {
				const href = e.target.getAttribute('href');
				if (href && href.startsWith('#') && href.length > 1) {
					const modalElement = document.querySelector(href + '.modal');
					if (modalElement) {
						e.preventDefault();
						show(href.replace('#', ''));
					}
				}
			}
		});
	}

	function show(id) {
		// Check if this is the contact modal and user is not logged in
		if (id === 'contact' && (!window.wpUser || !window.wpUser.isLoggedIn)) {
			alert('Please log in to use this feature');
			return;
		}
		
		MicroModal.show(id, config);
	}

	return {
		init: init,
		show: show,
	};
})();
